import InputWrapper from '@/shared/InputWrapper/InputWrapper';
import { Input, Space, Switch } from 'antd';
import useSortImagesConf from './useSortImagesConf.hook';

export default function SortImagesConf({ data, setConf }) {
  const { state, actions } = useSortImagesConf({ data, setConf });

  return (
    <Space direction="vertical">
      <strong>Configurable parameters</strong>
      <Space direction="vertical">
        <InputWrapper label="Questions per screen:">
          <Input
            type="number"
            value={state.questionsPerScreen}
            onChange={(event) => {
              const value = event.target.value;
              const validValue = value > 1 && value <= 4 ? value : 4;
              actions.setValue('questionsPerScreen', validValue);
            }}
            min={2}
            max={4}
          />
        </InputWrapper>
        <InputWrapper label="Show best students in the summary:">
          <div>
            <Switch
              checked={state.showBestStudents}
              onChange={(checked) =>
                actions.setValue('showBestStudents', checked)
              }
            />
          </div>
        </InputWrapper>
        <InputWrapper label="Seconds per screen:">
          <Input
            type="number"
            value={state.questionTimer}
            onChange={(event) => {
              actions.setValue('questionTimer', event.target.value);
            }}
            min={10}
            max={60}
          />
        </InputWrapper>
        <InputWrapper label="Seconds to see results of each screen:">
          <Input
            type="number"
            value={state.resultsTimer}
            onChange={(event) => {
              actions.setValue('resultsTimer', event.target.value);
            }}
            min={5}
            max={60}
          />
        </InputWrapper>
      </Space>
    </Space>
  );
}
